import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types';
import { FormRender } from '../../../../../forms/FormRenderer/types';
import { getKeyValueForElement } from '../../../../../utils/globals/valueOrDefaultValue';

export const personalizedValueOrDefaultValue = (fields: FormRender<any>, userPermissions: UserPermissions, values: any) => {
    for (const formSection of fields) {
        for (const element of formSection.elements) {
            const key = getKeyValueForElement(element.component, element as any)
            //@ts-ignore
            element[key] = element[key] ?? values[element.name]
            if (element.name !== 'LangId') {
                if (userPermissions.n <= 2   ) {
                    element.readOnly = true
                    // @ts-ignore
                    element.disabled = true
                }
            }
        }
    }
    return fields
}